import BlogList from "../../Components/Blog/BlogList";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import Pagebanner from "../../layout/Banner";

const Blogs = ()=>{
    return(
        <>
        <Header/>
        <Pagebanner title={"Legal Library"} subtitle={"Latest Legal Insights"}/>
        <BlogList/>
        <Footer/>   
        </>
    )
}
export default Blogs;